import png1 from "./1.jpg";
import png2 from "./2.jpg";
import png3 from "./3.jpg";
import png4 from "./4.jpg";
import png5 from "./5.jpg";
import png6 from "./6.jpg";
export const gfpayh = [
  {
    name: "查找流水",
    msgList: [
      {
        msg: "登录平安银行APP->顶部搜索【个人流水打印】->【个人账户交易明细申请】",
      },
      { imgs: [png1, png2, png3] },
    ],
  },
  {
    name: "发送账单",
    msgList: [
      {
        msg: "选择【全部交易】账单时间【一年】->文件类型【PDF】，填入专属邮箱【确认提交】",
      },
      { imgs: [png4, png5, png6] },
    ],
  },
  {
    name: "注意事项",
    msgList: [
      { msg: "【展示交易对手】【展示备注】选择【是】，文件类型选择【PDF】" },
    ],
  },
];
